<template>
  <div id="accounts-autocomplete">
    <!-- AJAX BASED AUTOCOMPLETE -->
    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :list="list"
      :searchOn="searchOn"
      :max-suggestions="5"
      :min-length="1"
      :debounce="500"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27]
      }"
      :mode="mode"
      ref="suggestComponent"
      value-attribute="id"
      display-attribute="name"
      @select="onSuggestSelect"
    >
      <div class="g">
        <input type="text" />
      </div>

      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div class="misc-item">
          <span>You're searching for '{{ query }}'.</span>
        </div>

        <template v-if="suggestions.length > 0">
          <!-- <div class="misc-item">
              <span>{{ suggestions.length }} suggestions are shown...</span>
            </div>
            <hr> -->
        </template>

        <div class="misc-item" v-else-if="!loading">
          <span>No results</span>
        </div>
      </template>

      <div
        slot="suggestion-item"
        slot-scope="scope"
        :title="scope.suggestion.description"
      >
        <div class="text">
          <span v-html="boldenSuggestion(scope)"></span>
        </div>
      </div>

      <div
        class="misc-item"
        slot="misc-item-below"
        slot-scope="{ suggestions }"
        v-if="loading"
      >
        <span>Loading...</span>
      </div>
    </vue-simple-suggest>
  </div>
</template>
<script>
import { boldenMatches } from "@/util/escapeHtml";
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import axios from "@/axios.js";

export default {
  props: ["list", "searchOn"],
  name: "AccountsAutocomplete",
  data() {
    return {
      chosen: "",
      selected: null,
      model: null,
      mode: "input",
      loading: false,
      log: []
    };
  },
  methods: {
    onSuggestSelect(suggest) {
      moduleClientUserManagement.state.client_users.datas = [];
      moduleClientsManagement.state.searched_clients = [];

      this.selected = suggest;
      if (this.searchOn == "client_user") {
        moduleClientUserManagement.selected_client_user = suggest;
        const clientUserId = suggest.id;
        this.$store
          .dispatch("clientUsersManagement/fetchClientUserList", clientUserId)
          .then(res => {
            this.$emit("event-name");
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.accountDescription = [];
              return;
            }
            console.error(err);
          });
      }

      if (this.searchOn == "client_and_client_user") {
        moduleClientUserManagement.selected_client_user = suggest;
        if (suggest.type == "client_user") {
          const clientUserId = suggest.id;
          this.$store
            .dispatch("clientUsersManagement/fetchClientUserList", clientUserId)
            .then(res => {
              this.$emit("event-name");
            })
            .catch(err => {
              if (err.response.status === 404) {
                this.accountDescription = [];
                return;
              }
              console.error(err);
            });
        } else {
          moduleClientsManagement.searched_clients = suggest;
          const client_id = suggest.id;
          this.$store
            .dispatch("clientsManagement/fetchClient", client_id)
            .then(res => {
              this.$emit("event-name");
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      // Release 2 (F2): the name is escaped before the matches are bolded, so a record name
      // can no longer run as HTML, and brackets typed in the search no longer break it.
      return boldenMatches(this.$refs.suggestComponent.displayProperty(suggestion), query);
    }
  },
  mounted() {},
  components: {
    VueSimpleSuggest,
    axios
  },
  created() {
    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }
  }
};
</script>
